import gql from 'graphql-tag'

export default gql`
  query ($id: Int!){
    notification(id: $id){
      id
      subject
      message
      office_id
      popup
      active
    }
  }
`